import { render } from "./AddItem.vue?vue&type=template&id=189f7cd7"
import script from "./AddItem.vue?vue&type=script&lang=js"
export * from "./AddItem.vue?vue&type=script&lang=js"

import "./AddItem.vue?vue&type=style&index=0&id=189f7cd7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__